import type { AxiosError } from 'axios';
import { toast } from 'sonner';

export function showGenericError(error: unknown) {
  const err = error as AxiosError<{ detail?: string }>;
  const errorMessage = err.response?.data?.detail || err.message;

  toast.error(`An error has occurred: ${errorMessage}`);
}
